import { useParams } from "react-router-dom";
import { TextMessageList } from "@/business-settings/text-messages/text-message-list";
import { useGetOptedOutTextMessages } from "@/text-messages/query";

export const OptedOutMessages = () => {
  const { businessId } = useParams();
  const { data: optedOutMessages, isLoading } =
    useGetOptedOutTextMessages(businessId);

  return (
    <TextMessageList
      textMessages={optedOutMessages}
      isLoading={isLoading}
      emptyMessage="No opted out messages (congrats!)"
    />
  );
};
